
<div class="chart-wrapper">
    <div class="chart-container">
        <div class="chart-total-title">Total sessions in the last 30 minutes</div>
        <div class="chart-total">{{ total }}</div>
        <h3>Active sessions per minute</h3>
        <div class="chart">
            <div *ngFor="let data of shopSessionRealtimeList trackBy: trackByFn"
                 class="bar"
                 [ngStyle]="{'height': data.sessionCount / getMaxSessionMinuteCount() * 100 + '%'}"
                 (mouseover)="onMouseOver(data, $event)"
                 (mouseout)="onMouseOut()"
                 (mousemove)="onMouseMove($event)">
            </div>
        </div>
    </div>

    <div *ngIf="tooltipVisible" class="tooltipBox" [ngStyle]="{'top': tooltipY + 'px', 'left': tooltipX + 'px'}">
        <div class="minutes-ago">{{selectedData.minutesBack}} minutes ago</div>
        <span class="session-display">Sessions:</span><span class="session-count">{{ selectedData.sessionCount }}</span>
    </div>

    <table class="country-table">
        <tbody>
        <tr *ngFor="let countryData of countryRealtime trackBy: trackByFn">
            <td>{{countryData.country}}</td>
            <td class="country-session-bar-cell">
                <div class="country-session-bar" [ngStyle]="getBarStyle(countryData.sessions, 'sessions')">
                    <span style="padding-left: 5px">{{ countryData.sessions }}</span>
                </div>
            </td>
        </tr>
        </tbody>
    </table>
</div>
